<template>
  <!--企业api管理-->
  <div class="api">
    <el-row type="flex" class="row">
      <el-col :span="queryParam.signStatusSet !== '-2' ? 6 : 10"></el-col>
      <el-col :span="6">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-select v-model="selectParam" placeholder="请选择" size="small">
              <el-option label="文件名称" value="contractName" />
              <el-option label="文件编号" value="applyNo" />
              <el-option label="签署方" value="signatoryFullName" />
              <el-option label="手机号" value="signatoryMobile" />
              <el-option label="证件号" value="signatoryIdentityCard" />
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="selectParamVal"
              size="small"
              placeholder="查询内容"
            />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" v-if="queryParam.signStatusSet !== '-2'">
        <div style="text-align: center; white-space: nowrap">
          <el-select
            style="width: 140px"
            v-model="selectedStatus"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="(item, index) in statusEnum"
              :label="item.label"
              :key="'status' + index"
              :value="item.value"
            />
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <el-row>
          <date-picker ref="data_picker" :paramDateArr.sync="paramDateArr" />
        </el-row>
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="getApplyList()" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-table
      v-loading="loading"
      class="data-list"
      :data="tableList"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="文件编号" show-overflow-tooltip width="220">
        <template slot-scope="scope">
          <nuxt-link
            v-if="scope.row.signStatus !== -6"
            :to="{
              path: '/applySign/toDetailAnony',
              query: { applyNo: scope.row.applyNo },
            }"
            target="_blank"
            >{{ scope.row.applyNo }}
          </nuxt-link>
          <span v-else>{{ scope.row.applyNo }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="文件名称"
        prop="contractName"
        show-overflow-tooltip
        width="220"
      />
      <el-table-column label="签署状态" show-overflow-tooltip>
        <template slot-scope="scope">{{
          getSignStatus(+scope.row.signStatus)
        }}</template>
      </el-table-column>
      <el-table-column
        label="签署方"
        prop="allSignerName"
        show-overflow-tooltip
      />
      <el-table-column label="发起时间" prop="createTime">
        <template slot-scope="scope">{{
          scope.row.createTime | formatDateHM
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template v-if="!scope.row.childSend" slot-scope="scope">
          <a
            v-if="scope.row.signStatus !== -6"
            @click="lookDetailFn(scope.row)"
            class="options-sty color-success pointer"
            target="_blank"
            >查看
          </a>
          <template
            v-if="scope.row.signStatus === 0 && scope.row.createType === 1"
          >
            <a
              href="javascript:void(0)"
              @click="batchCancel(scope.row)"
              class="options-sty color-success pointer"
              >撤销</a
            >
          </template>
          <template
            v-if="scope.row.signStatus === 1 && scope.row.createType === 0"
          >
            <a
              href="javascript:void(0)"
              @click="gotoTestify(scope.row)"
              class="options-sty color-success pointer"
              >证书</a
            >
          </template>
          <a
            v-if="scope.row.showQrCode && scope.row.showQrCode === 1"
            @click="getNoSingInfo(scope.row.applyNo)"
            href="javascript:void (0)"
            class="options-sty color-success pointer"
            >链接</a
          >
          <a
            v-if="scope.row.signStatus === 4"
            @click="lookDetailFn(scope.row, scope.row.terminationApplyNo)"
            class="options-sty color-success pointer"
            style="display: inline-block"
            target="_blank"
          >查看作废协议
          </a>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <el-row class="pageation row">
      <el-col :span="6">
        <el-button @click="exportList()" size="small">导出</el-button>
        <el-button @click="batchDown" size="small">下载</el-button>
        <!--<el-button @click="batchCancel()" size="small">删除</el-button>-->
      </el-col>
      <el-col :span="18" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :pager-count="5"
          :page-size="queryParam.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="queryParam.total"
        />
        <el-go
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="showChooseCert"
      title="请选择主体身份"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-if="certList && certList.length > 0">
        <template v-for="(item, index) in certList">
          <div :key="index">
            <el-radio v-model="choosedCert" :label="index">{{
              item.idenName
            }}</el-radio>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          @click="certificateJumpFn(certList[choosedCert])"
          size="small"
          type="danger"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!--用户扫码签选择用户 弹窗-->
    <el-dialog
      title="选择签署方"
      :visible.sync="visibleNoSignList"
      modal-append-to-body
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      width="550px"
    >
      <el-row v-if="noSign.data">
        <el-col
          v-for="(item, index) in noSign.data"
          :span="8"
          :key="index"
          class="font-ellipsis"
          style="margin-bottom: 10px"
        >
          <a
            @click="getNoSignUrl(item)"
            :title="item.fullName"
            href="javascript:void (0)"
            class="color-success"
            >{{ item.fullName | ellipsis(8) }}</a
          >
        </el-col>
      </el-row>
      <p class="text-right">
        <el-button @click="visibleNoSignList = false" size="small"
          >取消</el-button
        >
      </p>
    </el-dialog>
    <!--合同未签署方URL 弹窗-->
    <el-dialog
      :visible.sync="visibleNoSignUrl"
      modal-append-to-body
      append-to-body
      width="340px"
      class="contract-qrcode"
    >
      <div v-if="noSign.url" class="text-center nosign-url">
        <p>{{ noSign.name }}的签署链接</p>
        <qrcode :value="noSign.url" :size="200" leave="H" key="evidence" />
        <p style="margin-bottom: 10px">{{ noSign.url }}</p>
        <p>
          <el-button
            @click="
              visibleNoSignUrl = false;
              visibleNoSignList = false;
            "
            type="success"
            size="small"
            >确定</el-button
          >
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ApiMethods,
  postApplyPage,
  apiApplyToExce,
  noSignUrl,
  noSignList,
  configUrl
} from "../../assets/js/http-serve/http-methods";
import Qrcode from "qrcode.vue";
import ElGo from "../go/Go";
import datePicker from "../../components/date-picker/index";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  components: { Qrcode, ElGo, datePicker },
  data () {
    return {
      tableList: [],
      queryParam: {
        itemPage: 1,
        pageSize: 10,
        createType: 0,
        signStatusSet: null
      },
      currentPage: 1,
      selectParam: null,
      selectParamVal: "",
      paramDateArr: [],
      loading: false,
      checkedList: [],
      showChooseCert: false,
      certList: [],
      choosedCert: 0,
      // 合同没有签署的签署方信息和url
      noSign: { data: null, url: "", name: "" },
      visibleNoSignList: false,
      visibleNoSignUrl: false,
      selectedStatus: "",
      pickerOptions: {
        disabledDate: time => {
          console.log(time);
          return (
            time > new Date().getTime() + 24 * 60 * 60 * 1000 ||
            time < new Date().getTime() - 31 * 24 * 60 * 60 * 1000
          );
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    statusEnum () {
      return [
        {
          label: "全部",
          value: ""
        },
        {
          label: "已过期",
          value: "-6"
        },
        {
          label: "已撤消",
          value: "-5"
        },
        {
          label: "未完成",
          value: "0"
        },
        {
          label: "已结束",
          value: "1"
        },
        {
          label: "已拒签",
          value: "2"
        },
        {
          label: "已作废",
          value: "4"
        },
      ];
    }
  },
  mounted () {
    this.getApplyList();
  },
  methods: {
    //查看
    lookDetailFn(item, terminationApplyNo) {
      if (item.dealType === 6) {
        this.$message.error('当前为hash保全，无可预览文件');
      } else if (terminationApplyNo) {
        const url = this.$router.resolve({path: '/applySign/toDetailAnony', query: { applyNo: terminationApplyNo }});
        window.open(url.href, '_blank');
      } else {
        const url = this.$router.resolve({path: '/applySign/toDetailAnony', query: { applyNo: item.applyNo }});
        window.open(url.href, '_blank');
      }
    },
    getSignStatus (status) {
      const list = {
        "-7": "处理中",
        "-6": "已过期",
        "-5": "已撤消",
        "-4": "审批驳回",
        "-3": "待审批",
        "-2": "草稿",
        "-1": "处理中",
        "0": "未完成",
        "1": "已结束",
        "2": "已拒签",
        "3": "已保全",
        "4": "已作废",
      };
      return list[status];
    },
    // 获取合同没有签署的签署方信息
    getNoSingInfo (applyNo) {
      if (!applyNo) return;
      noSignList({ applyNo: applyNo }).then(({ data }) => {
        this.noSign.data = data || null;
        this.visibleNoSignList = true;
      });
    },
    getNoSignUrl (sign) {
      if (!sign) return;
      noSignUrl(sign.signNo).then(({ data }) => {
        if (data) {
          this.noSign.url = data;
          this.noSign.name = sign.fullName;
          this.visibleNoSignUrl = true;
        }
      });
    },
    batchDown () {
      if (!this.checkedList || this.checkedList.length === 0)
        return this.$confirm("请先选择需要下载的签署。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      this.loading = true;
      const batchApplyNos = this.checkedList.map(i => i.applyNo).join(",");
      ApiMethods.UseEnterpriseController.downloadBatch({
        applyNos: batchApplyNos
      })
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          this.downloadFile(res.data);
        })
        .finally(() => (this.loading = false));
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },

    exportList: function () {
      if (!this.paramDateArr || this.paramDateArr === "")
        return this.$message.error("请选择开始和结束时间");
      let param = JSON.parse(JSON.stringify(this.queryParam));
      if (
        this.selectParam &&
        this.selectParamVal &&
        this.selectParamVal != ""
      ) {
        param[this.selectParam] = this.selectParamVal;
      }
      if (this.paramDateArr && this.paramDateArr != "") {
        param.beginDate = this.paramDateArr[0];
        param.endDate = this.paramDateArr[1];
      }
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open();

      apiApplyToExce(param)
        .then(data => {
          if (data.data) {
            const path = configUrl().junziqianApi + data.data;
            isInDingTalk ? location.href = path : newWindow.location.href = path
          }
        })
        .catch(err => {
          if (!isInDingTalk) newWindow.close();
          console.log("exportList: " + JSON.stringify(err));
          this.$message.error(err.description || "初始化失败！");
        });
    },
    //证书跳转
    certificateJumpFn(data) {
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open("about:blank");
      ApiMethods.CertiController.redirectTesity({
        ...data,
        newUrl: 1,
      }).then(res => {
        if (res.success) {
          if (isInDingTalk) location.href = res.data;
          if (!isInDingTalk) newWindow.location.href = res.data;
        } else {
          this.$message.error(res.description || this.$tip);
          if (!isInDingTalk) newWindow.close();
        }
      });
    },
    gotoTestify: function (item) {
      var _this = this;
      var param = { applyNo: item.applyNo || "" };
      ApiMethods.UserApplySignController.certiUrl(param).then(result => {
        if (result.success) {
          if (result.data.length == 1) {
            // _this.$router.push({
            //   path: "/certi/certiPage",
            //   query: result.data[0]
            // });
            this.certificateJumpFn(result.data[0]);
          } else {
            _this.certList = result.data;
            _this.showChooseCert = true;
          }
        } else {
          _this.$message.error(result.description || "获取证书信息错误");
        }
      });
    },
    batchCancel: function (item) {
      var ids = [],
        dels = item ? [item] : this.checkedList;
      for (var i = 0; i < dels.length; i++) {
        ids.push(dels[i].applyId);
      }
      if (ids.length < 1) {
        return this.$alert("你还未选择要操作的数据", "系统提示");
      }
      this.$confirm("确定删除", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ApiMethods.UserApplySignController.batchCancel({
            applyIds: ids.join(",")
          }).then(result => {
            if (result.success) {
              this.$alert("操作成功", "系统提示", {
                confirmButtonText: "确定",
                callback: action => {
                  this.getApplyList();
                }
              });
              this.getApplyList();
            } else {
              this.$alert(result.description || "操作失败", "系统提示");
            }
          });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消操作" });
        });
    },
    // 重置
    rest () {
      this.selectParam = null;
      this.selectParamVal = "";
      this.selectedStatus = "";
      this.queryParam.itemPage = 1;
      this.$refs.data_picker.turnTime();
      this.getApplyList();
    },
    // 获取合同列表
    getApplyList: function () {
      let param = JSON.parse(JSON.stringify(this.queryParam));
      if (
        this.selectParam &&
        this.selectParamVal &&
        this.selectParamVal != ""
      ) {
        param[this.selectParam] = this.selectParamVal;
      }
      if (this.paramDateArr && this.paramDateArr != "") {
        param.beginDate = this.paramDateArr[0];
        param.endDate = this.paramDateArr[1];
      }
      param.signStatus = this.selectedStatus;
      this.loading = true;
      postApplyPage(param)
        .then(data => {
          this.queryParam.itemPage = data.pageNum;
          this.queryParam.pageSize = data.pageSize;
          this.queryParam.total = data.total;
          this.badge = data.total;
          this.tableList = data.data;
          this.$parent.badge = data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange (val) {
      this.queryParam.pageSize = val;
      this.getApplyList();
    },
    handleCurrentChange (val) {
      this.queryParam.itemPage = val;
      this.getApplyList();
    },
    handleSelectionChange: function (val) {
      this.checkedList = val;
    },
    toHistory () {
      let base = "http://ent.ebaoquan.org";
      if (this.globalConfig.domain.entEbq) {
        base = this.globalConfig.domain.entEbq;
      }
      const url = base + "/enterprise/contractPage";
      this.to(url, "_blank");
    },
    to: function (url, target) {
      isInDingTalk ? location.href = url : window.open(url, target);
    }
  },
  name: "api-set"
};
</script>

<style lang="less" scoped>
.options-sty{
  margin-right: 5px;
  color:#290202;
}
.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
  min-height: 85px;
}

.dialog-footer {
  padding-bottom: 20px;

  .btn {
    width: 30%;
  }
}
</style>

<style lang="less">
.contract-qrcode {
  .el-dialog__header {
    padding: 0;

    .el-dialog__headerbtn {
      top: 0;
      right: 0;
    }
  }
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// components/ent-access/apiSet.vue